import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import EcommerceHeader from "../components/EcommerceHeader";
import { EcommerceFooter } from "./EcommerceHome";
import { readCart, saveCart, saveOrder } from "../utils/ecommerceStorage";
import "../css/Ecommerce.css";

export default function EcommerceCheckout() {
  const navigate = useNavigate();
  const [cartItems, setCartItems] = useState([]);
  const [balance, setBalance] = useState(0);
  const [showInsufficientModal, setShowInsufficientModal] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    phone: "",
    address: "",
    landmark: "",
    city: "",
    pincode: "",
    state: "",
  });

  useEffect(() => {
    const cart = readCart();
    setCartItems(cart);
    setBalance(Number(localStorage.getItem("walletBalance") || 0));

    if (cart.length === 0) {
      navigate("/cart", { replace: true });
    }
  }, [navigate]);

  const totalPrice = cartItems.reduce((sum, item) => sum + item.product.price * item.quantity, 0);

  const updateField = (key, value) => {
    setFormData((current) => ({ ...current, [key]: value }));
  };

  const handleConfirmAndPay = (event) => {
    event.preventDefault();

    if (balance < totalPrice) {
      setShowInsufficientModal(true);
      return;
    }

    const newBalance = balance - totalPrice;
    const transactionId = `${Date.now()}`;
    const title = cartItems.map((item) => `${item.product.title} (x${item.quantity})`).join(", ");

    localStorage.setItem("walletBalance", String(newBalance));
    window.dispatchEvent(new Event("wallet-change"));

    saveOrder({
      id: transactionId,
      title,
      image: cartItems[0]?.product.image,
      price: totalPrice,
      fullName: formData.fullName,
      phone: formData.phone,
      address: [formData.address, formData.landmark, formData.city, formData.pincode, formData.state]
        .filter(Boolean)
        .join(", "),
      paymentMethod: "Wallet",
      transactionId,
      orderedAt: new Date().toISOString(),
      status: "Placed",
    });

    saveCart([]);
    navigate("/order-history");
  };

  return (
    <div className="ecomm-app-screen">
      <EcommerceHeader />

      <main className="ecomm-checkout-page">
        <h1>Delivery Details</h1>

        <section className="ecomm-checkout-summary">
          <div>
            <span>Order Total</span>
            <strong>₹{totalPrice}</strong>
          </div>
          <div>
            <span>Available Balance</span>
            <strong>₹{balance}</strong>
          </div>
        </section>

        <form className="ecomm-checkout-form" onSubmit={handleConfirmAndPay}>
          <div className="ecomm-checkout-grid">
            <input
              type="text"
              placeholder="Full Name"
              value={formData.fullName}
              onChange={(event) => updateField("fullName", event.target.value)}
              required
            />
            <input
              type="tel"
              placeholder="Phone"
              value={formData.phone}
              onChange={(event) => updateField("phone", event.target.value.replace(/\D/g, "").slice(0, 10))}
              inputMode="numeric"
              maxLength={10}
              required
            />
          </div>

          <input
            type="text"
            placeholder="Street Address"
            value={formData.address}
            onChange={(event) => updateField("address", event.target.value)}
            required
          />

          <input
            type="text"
            placeholder="Landmark (Optional)"
            value={formData.landmark}
            onChange={(event) => updateField("landmark", event.target.value)}
          />

          <div className="ecomm-checkout-grid">
            <input
              type="text"
              placeholder="City"
              value={formData.city}
              onChange={(event) => updateField("city", event.target.value)}
              required
            />
            <input
              type="text"
              placeholder="Pincode"
              value={formData.pincode}
              onChange={(event) => updateField("pincode", event.target.value.replace(/\D/g, "").slice(0, 6))}
              inputMode="numeric"
              maxLength={6}
              required
            />
          </div>

          <input
            type="text"
            placeholder="State"
            value={formData.state}
            onChange={(event) => updateField("state", event.target.value)}
            required
          />

          <button type="submit">Confirm & Pay ₹{totalPrice}</button>
        </form>
      </main>

      <EcommerceFooter active="cart" />

      {showInsufficientModal && (
        <div className="ecomm-insufficient-overlay">
          <div className="ecomm-insufficient-modal">
            <div className="ecomm-insufficient-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#d32f2f" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                <line x1="12" y1="9" x2="12" y2="13" />
                <line x1="12" y1="17" x2="12.01" y2="17" />
              </svg>
            </div>
            <h3>Insufficient Balance</h3>
            <p>Your wallet balance is not enough to cover this order. Please add funds to proceed.</p>
            <div className="ecomm-insufficient-actions">
              <button onClick={() => setShowInsufficientModal(false)}>Cancel</button>
              <button
                className="primary"
                onClick={() => {
                  setShowInsufficientModal(false);
                  navigate("/funds/add?simple=1", { state: { inactiveAddFund: true } });
                }}
              >
                Add Funds
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
